import { useRegistrationStore } from '../../hooks';
import { ComponentRegistrationModalView } from '../../components/ComponentRegistrationModalView';

export const ComponentRegistrationModal = () => {
  const registrationStore = useRegistrationStore();

  return <ComponentRegistrationModalView {...registrationStore} />;
};
